<template>
  <div>
    <div class="grid_flex mb-2">
      <div class="grid_flex">
        <div class="img_title_printerheader">
          <img :src="$props.img_header">
        </div>
        <h2 class="title_printerheader">{{ $props.header }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrinterHeader',
  data(){
    return{
      image:null
    }
  },
  props:['header','img_header','link_back'],
}
</script>

<style scoped>
.title_printerheader{
  margin-left: 10px;
}

.img_title_printerheader{
  width: 50px;
}

.img_title_printerheader > img{
  max-width: 100%;
}
.grid_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
